import React from "react";
import {Header, Grid} from "semantic-ui-react";

interface TicketModalHeaderProps {
    checkNumber: string;
}

export const TicketModalHeader: React.FC<TicketModalHeaderProps> = ({
    checkNumber
}) => {
    return (
        <Grid>
            <Grid.Row>
                <Grid.Column width={12}>
                    <Header as="h1">Receipt #{checkNumber}</Header>
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
};
